module.exports = __webpack_public_path__ + "img/newforest.d03eaab3.jpg";